export const data = [
  {
    title: "New Bookstore App",
    repo: "https://github.com/AmanKumarWeb19/New_BookStore_App.git",
    website: "https://new-bookstore-app.onrender.com/",
    project_thumbnail: "/bookstore.PNG ",
    txt1: "The New Bookstore App is a feature-rich MERN (MongoDB, Express, React, Node.js) project designed to simplify book browsing, searching, and management. With a responsive UI and secure backend, this app provides a seamless user experience for book enthusiasts.",
    tech: "Tech: Vite, Tailwind-Css, daisyui, react-hot-toast, react-slick-carousel, node.js, express.js,mongoose, mongodb, dotenv, nodemon.",
  },
  {
    title: "Wardrobe",
    repo: "https://github.com/gaurav62472744/Myntra.com",
    website: "https://halting-title-3346.vercel.app/",
    project_thumbnail: "/wardrobe.png",
    txt1: "This project was about creating a clone of Wardrobe website as the part of construct week project.Wardrobe is an e-commerce online website for the best fashion products of all categories for the consumer, This project was a result of the collaboration of four team members within five days.",
    tech: "Tech: React, Redux, Chakra-ui, Redux-thunk",
  },
  {
    title: "Himalaya",
    repo: "https://github.com/btcpatil/handy-zipper-9467",
    website: "https://friendly-pudding-a5d011.netlify.app/homepage/",
    project_thumbnail: "/himalaya.png",
    txt1: "This project was about creating a clone of Himalaya website as the part of construct week project.Himalaya offers a full line of clinically-studied herbal formulations.This website gives detailed information about each product and their medicinal benifits. This project was a result of the collaboration of five team members within five days.",
    tech: "Tech: JS, HTML and, CSS.",
  },
  {
    title: "J.Crew",
    repo: "https://github.com/rahuljithu123/happy-notebook-3138",
    website: "https://incandescent-mooncake-91ae01.netlify.app/",
    project_thumbnail: "/jcrew.png",
    txt1: "This project was about creating a clone of J.Crew website as the part of construct week project.The website offers an assortment of women's, men's, and children's apparel and accessories, This project was a result of the collaboration of five team members within five days.",
    tech: "Tech: JS, HTML and, CSS.",
  },

  {
    title: "Compaign Monitor",
    repo: "https://github.com/AmanKumarWeb19/volatile-pot-2156.git",
    website: "https://vermillion-parfait-2ba445.netlify.app/",
    project_thumbnail: "/Homepage.png",
    txt1: "This project was about creating a clone of Wardrobe website as the part of construct week project.Wardrobe is an e-commerce online website for the best fashion products of all categories for the consumer, This project was a result of the collaboration of four team members within five days.",
    tech: "Tech: React,Js,Css,Html",
  },
];
